import { Box, Button, Grid, Typography, makeStyles } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { useEffect, useState } from 'react';
import { getCommittees } from "../../../../services/committees.service";
import { Select } from "../../../Common/Select";
import Textarea from '../../../Common/Textarea';
import {
  ButtonsContainer,
  Content,
  FieldsContainer,
  HeaderContainer,
  OpenedInputDescription,
} from './styles';

const useStyles = makeStyles((theme) => ({
  button: {
    fontSize: "1rem",
    fontWeight: "bold",
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50
  },
  chip: {
    margin: 2,
  },
}));

function FilterDrawer({ onClose, t, filters, setFilters, actionShowSpinner }) {
  const classes = useStyles();

  const [committeesOptions, setCommitteesOptions] = useState([]);
  const [committee, setCommittee] = useState(filters.committee);
  const [openedField, setOpenedField] = useState(filters.keyword);
  
  useEffect(() => {
    const language = localStorage.getItem('i18nextLng');

    const loadCommitteeOptions = async () => {
      const response = await getCommittees({
        showDisabled: true,
        pageSize: 999999
      });
      
      setCommitteesOptions(
        response.data.items
      );
    };

    actionShowSpinner(true);

    loadCommitteeOptions();

    actionShowSpinner(false);
  }, []);

  useEffect(() => {
    setCommittee(filters?.committee);
    setOpenedField(filters?.keyword);
  }, [filters]);

  const handleApplyFilters = () => {
    setFilters({
      ...(committee && {committee: committee}),
      ...(openedField && {keyword: openedField}),
    });

    onClose();
  };

  const handleCleanFilters = () => {
    setFilters({
      committee: undefined,
      keyword: '',
    });

    onClose();
  };

  return (
    <Box
      sx={{ width: 460, flex: 1, display: 'flex' }}
      role="presentation"
    >
      <Content>
        <HeaderContainer>
          <Typography variant="h4">{t("forms.filters")}</Typography>

          <Close onClick={() => { onClose(); }} />
        </HeaderContainer>

        <FieldsContainer>
          <Grid container spacing={3}>
            <Grid item lg={12} xs={12}>
              <Select
                id="committee"
                options={committeesOptions}
                value={committee}
                label={t("slots.committee")}
                setValue={(value) => {
                  setCommittee(value);
                }}
              />
            </Grid>

            <Grid item lg={12} xs={12}>
              <Textarea
                name="freeField"
                id="freeField"
                onChange={(e) => setOpenedField(e.target.value)}
                value={openedField}
                style={{ width: '100%' }}
                label={t("forms.openedField")}
              />

              <OpenedInputDescription>
              {t("forms.committee.openedFieldThemes")}
              </OpenedInputDescription>
            </Grid>
          </Grid>
        </FieldsContainer>

        <ButtonsContainer>
          <Button
            variant="contained"
            onClick={handleCleanFilters}
            className={classes.buttonOutlined}
          >
            {t("forms.cleanFilters")}
          </Button>

          <Button
            variant="contained"
            onClick={handleApplyFilters}
            className={classes.button}
          >
            {t("forms.applyFilters")}
          </Button>
        </ButtonsContainer>
      </Content>
    </Box>
  );
}

export default FilterDrawer;